import axios from 'axios'

const getVendors = (localStorage, alert) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/spreadsheet/vendor`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log('response', response)
        resolve(response.data.data)
      })
      .catch(error => {
        alert('Please make sure to check the row you wanted to download')
      })
  })
}

export { getVendors }
